define('views/annotations/annotations',[
  "globals",
  "../abstract-comments/comments",
  "./list",
  "./form"
], function (globals, CommentSectionView, AnnotationListView, AnnotationFormView) {
  "use strict";

  return CommentSectionView.extend({
    createListView: function () {
      return new AnnotationListView({
        tagName: "div",
        className: "annotation-list",
        collection: this.collection
      });
    },

    createFormView: function () {
      return new AnnotationFormView({
        el: $("#annotation-form"),
        collection: this.collection
      });
    }
  });
});

